<div class="password-validation">
    {{#if errors.valid}}
        <div class="alert alert-success alert-icon" role="alert">
            <img src="/assets/img/icons/status-tick.svg" alt="" class="">
            <div class="content text-left">
                <h6 class="alert-heading">Password requirements met</h6>
            </div>
        </div>
    {{else}}
        <div class="validation_item">
            {{#if errors.min_lowercase.valid}} 
                <img src="/assets/img/icons/status-tick.svg" alt="">
                <span>{{errors.min_lowercase.text_label}}</span>
            {{else}}
                <div class="placeholder">&nbsp;</div>
                <span>{{errors.min_lowercase.text_label}}</span>
            {{/if}}
        </div>
        <div class="validation_item">
            {{#if errors.min_special_characters.valid}} 
                <img src="/assets/img/icons/status-tick.svg" alt="">
                <span>{{errors.min_special_characters.text_label}}</span>
            {{else}}
                <div class="placeholder">&nbsp;</div>
                <span>{{errors.min_special_characters.text_label}}</span>
            {{/if}}
        </div>
        <div class="validation_item">
            {{#if errors.min_uppercase.valid}} 
                <img src="/assets/img/icons/status-tick.svg" alt="">
                <span>{{errors.min_uppercase.text_label}}</span>
            {{else}}
                <div class="placeholder">&nbsp;</div>
                <span>{{errors.min_uppercase.text_label}}</span>
            {{/if}}
        </div>
        <div class="validation_item">
            {{#if errors.pwd_length.valid}} 
                <img src="/assets/img/icons/status-tick.svg" alt="">
                <span>{{errors.pwd_length.text_label}}</span>
            {{else}}
                <div class="placeholder">&nbsp;</div>
                <span>{{errors.pwd_length.text_label}}</span>
            {{/if}}
        </div>
        <div class="validation_item">
            {{#if errors.min_numbers.valid}} 
                <img src="/assets/img/icons/status-tick.svg" alt="">
                <span>{{errors.min_numbers.text_label}}</span>
            {{else}}
                <div class="placeholder">&nbsp;</div>
                <span>{{errors.min_numbers.text_label}}</span>
            {{/if}}
        </div>
        {{#if errors.dictionary}} 
            <div class="alert alert-error alert-icon" role="alert">
                <img src="/assets/img/icons/status-error.svg" alt="" class="">
                <div class="content text-left">
                    <h6 class="alert-heading">{{errors.dictionary.text_label}}</h6>
                </div>
            </div>
        {{/if}}
    {{/if}}

</div>